module.exports = __webpack_public_path__ + "static/media/menu_homea0cddc1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sidenav/images/menu_home.svg
// module id = 1231
// module chunks = 0